<template>
	<div class="css-loader"><div class="loader"></div></div>
</template>

<script>
	export default {
		name: "CssLoader"
	};
</script>

<style lang="scss" scoped>
	.loader {
		width: 50px;
		height: 50px;
		border: 5px solid rgba(255,255,255,0);
		border-radius: 50%;
		border-top-color: rgba(50,50,50,0.5);
		animation: spin 1s linear infinite;
		-webkit-animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		to { -webkit-transform: rotate(360deg); }
	}
	@-webkit-keyframes spin {
		to { -webkit-transform: rotate(360deg); }
	}
</style>
